<template>
  <el-input
    v-if="edit && !disabled"
    v-model="value"
    ref="input"
    :size="size"
    @change="update"
    @blur="update"
    @keyup.enter.native="update"
  />

  <span v-else @click="edit = true">
    {{ name }}
    <i class="el-icon-edit" />
  </span>
</template>

<script>
export default {
  props: {
    name: String,
    size: {
      type: String,
      default: 'medium'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      edit: false,
      value: this.name
    }
  },
  watch: {
    edit (value) {
      this.$nextTick(() => {
        if (value) {
          this.$refs.input.focus()
        }
      })
    }
  },
  methods: {
    update (value) {
      this.edit = false
      if (typeof (value) === 'string') {
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  span {
    i {
      visibility: hidden;
    }
    &:hover i {
      visibility: visible;
    }
  }
</style>
